import { api as AxiosRepository } from "./AxiosRepository";
const apiVersionBaseUrl = "/v1/campsites";

export default {
  getCampsites() {
    return AxiosRepository.get(apiVersionBaseUrl).then((response) => response.data);
  }
};
